module.exports = __webpack_public_path__ + "img/greycoolcreativetranssm.b8d452cb.webp";